import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../css/verifyOtp.css";
import engaggiologo from "../assets/engaggio-logo.png";

export default function VerifyOTP() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { verifyOTP, loading, error, resendOTP } = useAuth();

  // Get data from Login page 
  const { user_id, role } = location.state || {};

  const handleVerify = async (e) => {
    e.preventDefault();

    const userRole = await verifyOTP(user_id, otp, role);

    if (userRole === "parent") navigate("/parent");
    if (userRole === "learner") navigate("/child");
    if (userRole === "educator") navigate("/educator");
    if (userRole === "institution") navigate("/institution");
  };

  const handleResendOtp = async () => {
    if (!user_id) return;
    await resendOTP(user_id);
  };

  return (
    <div className="otp-wrapper">
      {/* Header */}
      <header className="otp-header">
        <img
          src={engaggiologo}
          alt="Engaggio Logo"
          className="otp-engaggio-logo"
        />
      </header>

      {/* Main */}
      <div className="otp-main">
        <form className="otp-card" onSubmit={handleVerify}>
          <h2>OTP Verification</h2>
          <p className="otp-subtitle">
            Enter the OTP sent to your email / phone
          </p>

          {error && <p style={{ color: "red" }}>{error}</p>}

          <div className="otp-input-group">
            <input
              type="text"
              maxLength="6"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
          </div>

          <button className="otp-button" disabled={loading}>
            {loading ? "Verifying..." : "Verify OTP"}
          </button>

          <p className="otp-resend">
            Didn’t receive OTP? <span onClick={handleResendOtp}>Resend</span>
          </p>
        </form>
      </div>
    </div>
  );
}